import { User } from 'firebase/auth'
import { createContext, useContext } from 'react'

export interface AuthedUser extends User {
  email: string
}

interface AuthContextType {
  user: AuthedUser
  isAdmin: boolean
  privateStoragePath: string | null
  publicStoragePath: string | null
}

export const AuthContext = createContext<AuthContextType>({
  user: {} as AuthedUser,
  isAdmin: false,
  privateStoragePath: null,
  publicStoragePath: null,
})

export function useAuth() {
  return useContext(AuthContext)
}
